import React,{useEffect,useRef} from 'react';
import {NumericFormat} from "react-number-format";
import {Const} from "../../Common/const";
import BaseSelect, { components }  from 'react-select';

export const InputField = ({
   className = "",
   placeholder="Nhập",
   type="text",
   autoComplete="off",
   error,
   touched = false,
   ...props
}) => {
    return(
        <input
            type={type} 
            className={`form-control ${error && touched ? ' border-danger' : ''}` + className} 
            autoComplete={autoComplete} 
            placeholder={placeholder}
            {...props}
        />
    )
}
export const NumberFormat = ({
    thousandSeparator = ',',
    decimalSeparator='.',
    decimalScale,
    placeholder = "Nhập số",
    className="",
    isAllowed,
    isDisabled = false,
    error,
    touched = false,
    ...props
}) => {
    const isAllowedDefault = isAllowed ?? 
        ((values) => {
            const {floatValue} = values
            return floatValue === undefined || floatValue <= Const.NUMBER_MAX_LIMIT;
        })
    placeholder = !isDisabled ? placeholder : "";
    return (
        <NumericFormat
            type={"text"}
            disabled={isDisabled}
            isAllowed={isAllowedDefault}
            thousandSeparator={thousandSeparator}
            decimalSeparator={decimalSeparator}
            decimalScale={decimalScale}
            placeholder={placeholder}
            autoComplete={'off'}
            className={`form-control ${error && touched ? ' border-danger' : ''}` + className}
            {...props}
        />
    );
}
export const RadioField = ({className = "",options = [],checkedValue = "",error,touched,...props}) => {
    return (
        <div className={`${className} radio ${error && touched ? "has-error" : ""}`}>
            {
                options.map(opt => {
                    return (
                        <label key={opt.key}>
                            <input {...props} type="radio" checked={checkedValue === opt.key} value={opt.key}/>
                            <span className={"radio-label"}>{opt.label}</span>
                        </label>
                    );
                })
            }
        </div>
    );
}
const CustomValueContainer = (props) => {
    const { children, getValue } = props;
    const selectedOption = getValue()[0];
    const ref = useRef(null);
    useEffect(() => {
        if(!ref.current) return;
        bootstrap?.Tooltip?.getInstance(ref.current)?.dispose();
        
        if(selectedOption?.label){
            new bootstrap.Tooltip(ref.current,{
                placement: "top",
                title: selectedOption.label,
                trigger: "hover"
            })
        }
    },[selectedOption])
    return (
        <div ref={ref} style={{flex: 1}}>
            <components.ValueContainer {...props}>
                {children}
            </components.ValueContainer>
        </div>
    );
};
export const SelectField = ({
    className = "",
    placeholder = "Chọn",
    isMulti = false,
    options = [],
    isSearchable = true,
    noOptionsMessage = "Trống",
    isClearable = false,
    handleChange,
    value,
    closeMenuOnSelect = true,
    hideSelectedOptions = true,
    styles,
    userComponents,
    menuPosition="absolute",
    menuPlacement="auto",
    menuPortalTarget = document.body,
    showTooltipOnHover = false,
    error,
    touched = false,
    ...props
}) => {
    
    const internalComponents = {
        ...userComponents,
    }
    if(showTooltipOnHover) internalComponents.ValueContainer = CustomValueContainer
    const newStyles = {
        ...styles,
        control: styles?.control ?? ((provided,state) => ({
           ...provided,
            color: '#031b4e',
            borderColor: error && touched
                ? "#ec1c24"
                : state.isFocused
                    ? "#2684FF"
                    : provided.borderColor,
            boxShadow: error && touched
                ? "0 0 0 1px #ec1c24"
                : state.isFocused
                    ? "0 0 0 1px #2684FF"
                    : provided.boxShadow,
            "&:hover": {
                borderColor: error && touched ? "#ec1c24" : "#2684FF"
            }
        })),
        singleValue: styles?.singleValue ?? ((provided) => ({
            ...provided,
            color: '#031b4e', 
        })),
        multiValue: styles?.multiValue ?? ((provided) => ({
            ...provided,
            backgroundColor: "#F0F1F6"
        })),
        multiValueLabel: styles?.multiValueLabel ?? ((provided) => ({
            ...provided,
            color: '#002147',
        })),
        multiValueRemove: styles?.multiValueRemove ?? ((provided) => ({
            ...provided,
           color: '#9CA5B9' 
        })),
        option: styles?.option ?? ((provided) => ({
            ...provided,
            color: "#031b4e"
        })),
    };
    return(
        <BaseSelect
            closeMenuOnSelect={closeMenuOnSelect}
            hideSelectedOptions={hideSelectedOptions}
            menuPosition={menuPosition}
            menuPlacement={menuPlacement}
            menuPortalTarget={menuPortalTarget}
            isMulti={isMulti}
            styles={newStyles}
            isSearchable={isSearchable}
            className={className}
            placeholder={placeholder}
            isClearable={isClearable ?? false}
            noOptionsMessage={() => noOptionsMessage}
            options={options}
            onChange={handleChange}
            value={value}
            components={internalComponents}
            {...props}>
        </BaseSelect>
    )
}